// Services
import { apiServices } from "@core/services/appService";

// Redux
import { setStatusSpinner } from "@core/redux/actions/app/spinner";

const LOAD_DATA_CAMP_ALL = 'app/camp/LOAD_DATA_CAMP_ALL';
const SET_SELECT_CAMP = 'app/camp/SET_SELECT_CAMP';
const SET_SELECT_CAMP_ID = 'app/camp/SET_SELECT_CAMP_ID';

// ⭐ เพิ่ม key ใหม่
const LOAD_DATA_CAMP_LOGO_MAP = 'app/camp/LOAD_DATA_CAMP_LOGO_MAP';

function loadDataCampAll(dataJson) {
    return dispatch => {

        apiServices({}, "get",
            `/general/list/camp-cache/${dataJson.type}/${process.env.REACT_APP_DEFAULT_AGENT_CODE}`
        ).then((data) => {

            const { code: statusCode, result } = data;
            dispatch(setStatusSpinner({ status: false, textProcess: null }));

            if (statusCode === 200 || statusCode === 0) {

                // ⭐ Build Map ตรงนี้เลย
                const logoMap = {};
                if (Array.isArray(result)) {
                    result.forEach((c) => {
                        const key = (c.camp || "").toString().trim().toLowerCase();

                        if (key) {
                            logoMap[key] = c.logo_list || "";
                        }
                    });
                }

                // ⭐ เก็บ camp list
                dispatch({
                    type: LOAD_DATA_CAMP_ALL,
                    payload: { items: result }
                });

                // ⭐ เก็บ map
                dispatch({
                    type: LOAD_DATA_CAMP_LOGO_MAP,
                    payload: { items: logoMap }
                });
            }
            else {
                dispatch({
                    type: LOAD_DATA_CAMP_ALL,
                    payload: { items: [] }
                });

                dispatch({
                    type: LOAD_DATA_CAMP_LOGO_MAP,
                    payload: { items: null }
                });
            }
        });
    };
}

function setSelectCamp(data) {
    return {
        type: SET_SELECT_CAMP,
        payload: {
            items: data
        }
    }
}

function setSelectCampId(data) {
    return {
        type: SET_SELECT_CAMP_ID,
        payload: {
            items: data
        }
    }
}



export {
    LOAD_DATA_CAMP_ALL,
    SET_SELECT_CAMP,
    SET_SELECT_CAMP_ID,
    LOAD_DATA_CAMP_LOGO_MAP,
    loadDataCampAll,
    setSelectCamp,
    setSelectCampId
}